import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

import { ReactComponent as LeftArrowIcon } from 'assets/icons/orangeLeftArrow.svg';
import { ReactComponent as CrossIcon } from 'assets/icons/crossIcon2.svg';
import { ReactComponent as ShareIcon } from 'assets/icons/shareIcon.svg';
import { ReactComponent as Copy } from 'assets/icons/copy.svg';
import { ReactComponent as Move } from 'assets/icons/move.svg';
import { ReactComponent as CorrectIcon } from 'assets/icons/correctIcon.svg';
import { ReactComponent as NoFoldersAndFiles } from 'assets/icons/noFoldersorFiles.svg';

import SecondaryButton from 'components/secondaryButton';
import PrimaryButton from 'components/primaryButton';
import { Checkbox, Table, Tooltip } from '@mantine/core';

// import useGetFolders from '../../hooks/useGetFolders';
import useGetIntoFolders from '../../hooks/useGetIntoFolder';
import { useState } from 'react';
import AddNewSubFolderModal from './addNewSubFolderModal';
import FoldersAndFilesTable from './foldersandfilesTable';
import AddANewFileModal from './addANewFileModal';
import { useEffect } from 'react';
import { saveAs } from 'file-saver';

import useDeleteSubFolderorFile from '../../hooks/useDeleteSubFolder0rFile';
import MoveFilesOrFolders from './moveFilesOrFolders';
import Reuploader from './reuploder';
// import UploadFileModal from './uppyFileUploder';

const SubFolders = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const pathFilesAndFolders = useGetIntoFolders(location?.state?.path);

  const [addSubFolderModal, setAddSubFolderModal] = useState(false);
  const [addSubFileModal, setAddSubFileModal] = useState(false);

  const [tableData, setTableData] = useState([]);
  const [moveFilesModal, setMoveFilesModal] = useState(false);
  const [copyOrMove, setCopyOrMove] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [lastUploadData, setLastUploadData] = useState([]);
  const [reUploadModal, setReuploadModal] = useState(false);
  const [lastGetData, setlastgetData] = useState([]);
  const [isAllUploded, setIsallUploded] = useState(false);
  useEffect(() => {
    setTableData(
      pathFilesAndFolders?.data?.data?.map((each) => {
        return { ...each, is_checked: false };
      })
    );
  }, [pathFilesAndFolders?.data?.data]);

  const rows = tableData?.map((each) => (
    <FoldersAndFilesTable
      key={each?.id}
      data={each}
      tableData={tableData}
      setTableData={setTableData}
      isAllUploded={isAllUploded}
      setIsallUploded={setIsallUploded}
      selectAll={selectAll}
      setSelectAll={setSelectAll}
    />
  ));

  const foldername = location?.state?.path?.split('/')?.pop();

  const isAnySelected = tableData?.some((each) => each?.is_checked === true);

  const multipleDelete = useDeleteSubFolderorFile();

  // eslint-disable-next-line
  const pathsObjects = tableData?.filter((each) => {
    if (each?.is_checked) {
      return `${location?.state?.path}/${each?.name}`;
    }
  });

  // eslint-disable-next-line
  const paths = pathsObjects?.map((each) => {
    if (each?.is_checked) {
      return `${location?.state?.path}/${each?.name}`;
    }
  });

  console.log(pathsObjects, paths);

  function getDifference(array1, array2) {
    return array1?.filter((object1) => {
      return array2?.find((object2) => {
        return object2?.name === object1?.name;
      });
    });
  }

  // console.log(
  //   lastUploadData,
  //   lastGetData,
  //   getDifference(lastUploadData, lastGetData)
  // );

  const differenceData = getDifference(lastUploadData, lastGetData);

  useEffect(() => {
    if (differenceData?.length !== 0) {
      setReuploadModal(true);
    } else {
      setReuploadModal(false);
      setLastUploadData([]);
    }
    // eslint-disable-next-line
  }, [addSubFileModal]);

  const { id } = useParams();

  const backpath = location?.state?.path.split('/');

  return (
    <>
      <div className='mt-1 bg-[#ffffff] min-h-[77vh] shadow-three rounded-2xl p-5'>
        <div className='flex justify-between items-center mt-2'>
          <h1 className='flex items-center gap-2 text-[#333333] font-semibold'>
            {location?.state?.mainpath === location?.state?.path ? (
              <Tooltip
                label={'Back'}
                wrapLines
                classNames={{
                  body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
                }}
                radius='md'
              >
                <LeftArrowIcon
                  className='h-5 w-8 cursor-pointer'
                  onClick={() => navigate('/app/repository', { replace: true })}
                />
              </Tooltip>
            ) : (
              <Link
                to={`/app/repository/${id}`}
                state={{
                  path: backpath.slice(0, backpath.length - 1).join('/'),
                  mainpath: location?.state?.mainpath,
                }}
              >
                <Tooltip
                  label={'Back'}
                  wrapLines
                  classNames={{
                    body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
                  }}
                  radius='md'
                >
                  <LeftArrowIcon className='h-5 w-8 cursor-pointer' />
                </Tooltip>
              </Link>
            )}

            {foldername}
          </h1>
          <div className='flex items-center gap-3'>
            {isAnySelected && (
              <div className='text-[#A8A8A8] text-sm flex items-center gap-3'>
                <p
                  className='flex items-center gap-1 cursor-pointer'
                  onClick={() => {
                    // eslint-disable-next-line
                    tableData?.map((each) => {
                      if (each?.is_checked && !each?.is_directory) {
                        saveAs(each?.url, each?.name);
                      }
                    });
                    setSelectAll(false);
                    setTableData(
                      pathFilesAndFolders?.data?.data?.map((each) => {
                        return { ...each, is_checked: false };
                      })
                    );
                  }}
                >
                  <LeftArrowIcon className='h-4 w-4 -rotate-90' />
                  Download
                </p>
                <p className='flex items-center gap-1 cursor-not-allowed opacity-50'>
                  <ShareIcon className='h-4 w-4' />
                  Share
                </p>
                <p
                  className='flex items-center gap-1 cursor-pointer'
                  onClick={() => {
                    setSelectAll(false);

                    multipleDelete.mutate({ paths });
                    setTableData(
                      pathFilesAndFolders?.data?.data?.map((each) => {
                        return { ...each, is_checked: false };
                      })
                    );
                  }}
                >
                  <CrossIcon className='h-4 w-4 border-primary border-2 rounded-3xl border-opacity-80' />
                  Delete
                </p>
                <p
                  className='flex items-center gap-1 cursor-pointer'
                  onClick={() => {
                    setSelectAll(true);
                    setTableData(
                      pathFilesAndFolders?.data?.data?.map((each) => {
                        return { ...each, is_checked: true };
                      })
                    );
                  }}
                >
                  <CorrectIcon className='h-4 w-4 border-primary border-2 rounded-3xl border-opacity-80' />
                  Select All
                </p>
                <p
                  className='flex items-center gap-1 cursor-pointer'
                  onClick={() => {
                    setSelectAll(false);
                    setTableData(
                      pathFilesAndFolders?.data?.data?.map((each) => {
                        return { ...each, is_checked: false };
                      })
                    );
                  }}
                >
                  <CrossIcon className='h-3 w-3 ' />
                  {pathsObjects?.length} selected
                </p>
                <p
                  className='flex items-center gap-1 cursor-pointer'
                  onClick={() => {
                    setMoveFilesModal(true);
                    setCopyOrMove('Move');
                  }}
                >
                  <Move className='h-4 w-4' />
                  Move
                </p>
                <p
                  className='flex items-center gap-1 cursor-pointer'
                  onClick={() => {
                    setMoveFilesModal(true);
                    setCopyOrMove('Copy');
                  }}
                >
                  <Copy className='h-4 w-4' />
                  Copy
                </p>
              </div>
            )}
            <button onClick={() => setAddSubFileModal(true)}>
              <SecondaryButton>Upload a file</SecondaryButton>
            </button>
            <button onClick={() => setAddSubFolderModal(true)}>
              <PrimaryButton>New folder</PrimaryButton>
            </button>
          </div>
        </div>
        <div className='mt-4'>
          <Table verticalSpacing='lg' highlightOnHover>
            <thead>
              <tr>
                <th
                  className='bg-[#FFE8E1] rounded-tl-xl'
                  style={{ textAlign: 'center', paddingLeft: '30px' }}
                >
                  <Checkbox
                    className='h-2  w-2'
                    size='xs'
                    radius={'lg'}
                    checked={selectAll}
                    onClick={() => {
                      setSelectAll(!selectAll);
                      if (!selectAll) {
                        setTableData(
                          pathFilesAndFolders?.data?.data?.map((each) => {
                            return { ...each, is_checked: true };
                          })
                        );
                      } else {
                        setTableData(
                          pathFilesAndFolders?.data?.data?.map((each) => {
                            return { ...each, is_checked: false };
                          })
                        );
                      }
                    }}
                  />
                </th>
                <th
                  className='bg-[#FFE8E1]  w-4/12'
                  style={{ textAlign: 'start', paddingLeft: '40px' }}
                >
                  Name
                </th>
                <th
                  className='bg-[#FFE8E1] '
                  style={{ textAlign: 'right', paddingRight: '50px' }}
                >
                  Action
                </th>
                <th style={{ textAlign: 'center' }} className='bg-[#FFE8E1]'>
                  Modified{' '}
                </th>{' '}
                <th
                  style={{ textAlign: 'center' }}
                  className='bg-[#FFE8E1]  rounded-tr-xl'
                >
                  Modified by
                </th>
                {/* <th className='bg-[#FFE8E1]' style={{ textAlign: 'center' }}>
                  Modified
                </th>

                <th
                  className='bg-[#FFE8E1] rounded-tr-xl'
                  style={{ textAlign: 'center' }}
                >
                  Modified by
                </th> */}
              </tr>
            </thead>

            <tbody className=' w-full max-h-20 border-none'>{rows}</tbody>
          </Table>
          {pathFilesAndFolders?.data?.data?.length === 0 && (
            <div className='flex justify-center items-center my-8 py-5 flex-col'>
              <NoFoldersAndFiles style={{ height: '180px', width: '180px' }} />
              <p className='text-gray mt-4 text-[18px]'>
                No folder or files to show
              </p>
            </div>
          )}
        </div>
      </div>
      <AddNewSubFolderModal
        addSubFolderModal={addSubFolderModal}
        setAddSubFolderModal={setAddSubFolderModal}
      />
      {addSubFileModal && (
        <AddANewFileModal
          addSubFileModal={addSubFileModal}
          setAddSubFileModal={setAddSubFileModal}
          setLastUploadData={setLastUploadData}
          setlastgetData={setlastgetData}
          isAllUploded={isAllUploded}
          setIsallUploded={setIsallUploded}
        />
      )}
      <MoveFilesOrFolders
        moveFilesModal={moveFilesModal}
        setMoveFilesModal={setMoveFilesModal}
        path={paths}
        copyOrMove={copyOrMove}
        setCopyOrMove={setCopyOrMove}
      />
      {/* <UploadFileModal
        isUploadModalOpen={addSubFileModal}
        setUploadModalOpen={setAddSubFileModal}
      /> */}
      <Reuploader
        reUploadModal={reUploadModal}
        setReuploadModal={setReuploadModal}
        setLastUploadData={setLastUploadData}
        differenceData={differenceData}
        lastUploadData={lastUploadData}
      />
    </>
  );
};

export default SubFolders;
